import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    modalHeadline: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
    },
    modalListWrapper: {
      paddingInlineStart: theme.spacing(2),
    },
    modalDisclaimer: {
      lineHeight: 0.5,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.grey[100],
      padding: theme.spacing(2),
      '& span': {
        lineHeight: 1.2,
      },
    },
    marginTopAdjustment: {
      marginTop: theme.spacing(-2),
    },
  })
)
